
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystacarhireforeventpune() {



    const cardData =
    {
        keyword: 'Innova Crysta Car Hire for Events Pune',
        heading: 'Meghana Cab : Innova Crysta Car Hire for Events Pune',
        headingDescription: 'Meghana Cab offers Innova Crysta Car Hire for Events in Pune, providing a luxurious, spacious, and reliable transportation solution for weddings, corporate gatherings, conferences, exhibitions, and private celebrations. Our Innova Crysta vehicles come equipped with plush leather seats, air-conditioning, ample legroom, and generous luggage space—perfect for comfortably transporting VIP guests, delegates, or family groups. Whether you need point-to-point service, full-day rentals, or custom shuttle solutions, Meghana Cab ensures seamless coordination with professional chauffeurs, on-time pickups, and flexible booking options. With 24/7 customer support and door-to-door service, book your Innova Crysta Car for Events in Pune with Meghana Cab and elevate your event logistics with style and convenience.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Ratnadurg Fort",
    "description": "Also known as Bhagawati Fort, this 16th-century sea fort perches atop a rocky promontory just 2 km from Ratnagiri town. The fort’s sturdy bastions, an inside Bhagawati temple, lighthouse, well, and cave offer a scenic walk with sweeping Arabian Sea views—ideal for history buffs and photographers alike."
  },
  {
    "title": "Jaigad Fort & Lighthouse",
    "description": "Set on a cliff at the mouth of the Shastri River, Jaigad Fort is a dramatic coastal citadel dating to Bijapur Sultanate and later fortified under Maratha admiral Kanhoji Angre. Its ramparts, lighthouse, and jetty reveal panoramic views of the sea and local fishing life. The ruins and vantage points make it a Konkan must-visit."
  },
  {
    "title": "Swayambhu Ganapati Temple & Ganpatipule Beach",
    "description": "About 35 km from Ratnagiri, Ganpatipule is famed for its pristine silver sands and the 400‑year‑old self‑manifested Ganapati idol embedded in white sand. The temple and beach combo make it a leading spiritual and seaside escape—cool sea breeze, coastal devotion, and stunning sunsets."
  },
  {
    "title": "Purnagad Fort",
    "description": "Perched at the confluence of Muchkundi creek and the Arabian Sea, this lesser-known Maratha-era fort offers rugged coastal vistas, a Hanuman shrine, and a historic well. With fewer tourists, Purnagad is perfect for quiet exploration and dramatic sea views."
  },
  {
    "title": "Tilak Ali Museum",
    "description": "The ancestral home of Lokmanya Bal Gangadhar Tilak, this museum showcases originals—photographs, letters, relics—and reflects Konkan-style architecture. A meaningful stop for history enthusiasts tracing India’s independence journey."
  },
  {
    "title": "Patit Pavan Mandir",
    "description": "Built in 1931 by freedom fighter Veer Savarkar, this temple broke caste barriers by allowing entry to all communities. It’s a historic beacon of social reform and spiritual aspiration, hosting open prayers and annual Ganesh festivals."
  },
  {
    "title": "Bhatye & Mandvi Beaches",
    "description": "Close to the city, Mandvi and adjacent Bhatye Beach offer long, serene stretches of golden sand backed by Sahyadri foothills. These family-friendly beaches are ideal for sunsets, casual strolls, and local snacks without the crowds."
  },
  {
    "title": "Pawas & Thibaw Palace",
    "description": "Pawas is a serene temple town associated with saint Swami Swaroopanand, while nearby Thibaw Palace was once the exile residence of Burma’s last king. Both sites blend spiritual calm and colonial-era intrigue."
  },
  {
    "title": "Panhalakaji Caves",
    "description": "About 20 km inland, Panhalakaji houses 29 rock-cut caves—Buddhist and later Hindu—dating from the 3rd to 11th centuries. The complex includes stupas, Brahmi inscriptions, and sculptural reliefs, linked by forest trails beside the Kotjai stream."
  },
  {
    "title": "Gopalgad (Anjanvel) & Mandangad Forts",
    "description": "Sea forts like Gopalgad (Anjanvel) and hill forts like Mandangad offer rugged trekking, Maratha-era cannons, forest views, and religious sites like Ganpati shrines—ideal for adventurous history seekers."
  }
],

      "services": [
    {
      "name": "Innova Crysta Car Hire for Wedding Pune",
      "description": "Make your special day memorable with our Innova Crysta car hire service for weddings in Pune. Enjoy spacious, elegant, and comfortable rides with professional chauffeurs ensuring timely arrivals and smooth travel for the bridal party and guests."
    },
    {
      "name": "Event Car Rental Innova Crysta Pune",
      "description": "Rent an Innova Crysta for any event in Pune — from family gatherings to corporate meetups. Our premium vehicles and courteous drivers guarantee a hassle-free and luxurious travel experience tailored to your event schedule."
    },
    {
      "name": "Corporate Event Innova Crysta Hire Pune",
      "description": "Opt for our reliable and professional Innova Crysta hire service for corporate events in Pune. Perfect for transporting executives, guests, and staff with comfort, punctuality, and style."
    },
    {
      "name": "Birthday Party Innova Crysta Car Rental Pune",
      "description": "Celebrate birthdays in style with our Innova Crysta car rental service. Whether it’s a surprise party or a group outing, our spacious vehicles offer convenience and luxury for a fun-filled day."
    },
    {
      "name": "Chauffeur Driven Event Car Pune",
      "description": "Enjoy stress-free event travel with our chauffeur-driven Innova Crysta cabs. Our professional drivers ensure safe, timely, and courteous service throughout your special occasion."
    },
    {
      "name": "Online Event Car Booking Pune",
      "description": "Book your Innova Crysta event car conveniently online with instant confirmations, transparent pricing, and flexible scheduling options tailored to your Pune event needs."
    },
    {
      "name": "Luxury Innova Crysta Hire Pune",
      "description": "Experience premium comfort and style with our luxury Innova Crysta hire service in Pune. Perfect for upscale events, VIP guests, and anyone wanting to travel in elegance."
    },
    {
      "name": "Affordable Innova Crysta Rental Pune",
      "description": "Get the best value for your event transportation with our affordable Innova Crysta rentals in Pune. Quality service and comfort without straining your budget."
    },
    {
      "name": "Festival Car Hire Innova Crysta Pune",
      "description": "Travel safely and comfortably during festival celebrations with our Innova Crysta car hire service in Pune. Ideal for group travels, family outings, and festive events."
    },
    {
      "name": "Special Occasion Car Rental Pune",
      "description": "Celebrate special occasions with our dedicated Innova Crysta car rental. Enjoy punctual, comfortable, and stylish travel for anniversaries, reunions, and more."
    },
    {
      "name": "Premium Event Taxi Pune",
      "description": "Hire premium Innova Crysta taxis for your event in Pune to ensure a luxurious and professional transportation experience for all your guests."
    },
    {
      "name": "Comfortable Innova Crysta Event Cab",
      "description": "Our Innova Crysta event cabs offer comfortable seating, ample luggage space, and air conditioning to keep your guests relaxed throughout the journey."
    },
    {
      "name": "Family Event Innova Crysta Hire",
      "description": "Perfect for family events in Pune, our Innova Crysta hire provides spacious seating and safety features, making group travel convenient and enjoyable."
    },
    {
      "name": "Conference Car Rental Pune",
      "description": "Organizing a conference? Our Innova Crysta car rental service ensures reliable, professional transportation for speakers, delegates, and attendees in Pune."
    },
    {
      "name": "Group Event Car Booking Pune",
      "description": "Book Innova Crysta cabs for group events in Pune to accommodate everyone comfortably with ample space and chauffeur-driven convenience."
    }
  ],
  "tableData": [
    ["Innova Crysta Car Hire for Wedding Pune", "Event Car Rental Innova Crysta Pune"],
    ["Corporate Event Innova Crysta Hire Pune", "Birthday Party Innova Crysta Car Rental Pune"],
    ["Chauffeur Driven Event Car Pune", "Online Event Car Booking Pune"],
    ["Luxury Innova Crysta Hire Pune", "Affordable Innova Crysta Rental Pune"],
    ["Festival Car Hire Innova Crysta Pune", "Special Occasion Car Rental Pune"],
    ["Premium Event Taxi Pune", "Comfortable Innova Crysta Event Cab"],
    ["Family Event Innova Crysta Hire", "Conference Car Rental Pune"],
    ["Group Event Car Booking Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Car Hire for Events in Pune",
    "WhyChoosedescription": "Make your special occasions memorable with our luxurious Innova Crysta car hire service. Perfect for weddings, corporate events, parties, and gatherings, we provide a stylish and comfortable ride tailored to your event needs."
  },
  {
    "WhyChooseheading": "Spacious and Elegant Vehicles",
    "WhyChoosedescription": "Our Innova Crysta cars offer plush interiors, ample legroom, and seating for up to 7 passengers, ensuring that you and your guests travel in comfort and style during any event in Pune."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs with Event Experience",
    "WhyChoosedescription": "Our courteous and well-trained drivers understand the importance of event timings and etiquette. They ensure punctual pickups and drop-offs, smooth navigation through Pune traffic, and a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Event Schedules",
    "WhyChoosedescription": "Whether you need hourly rentals, full-day services, or multi-day event transportation, we offer customizable packages to suit your event itinerary and requirements."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our Innova Crysta cars are regularly serviced, cleaned, and sanitized to maintain high hygiene standards, ensuring a safe and pleasant journey for you and your guests."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear and competitive pricing that includes fuel, driver allowance, tolls, and taxes. No surprise fees—just honest and upfront costs for your event car hire."
  },
  {
    "WhyChooseheading": "Ideal for Weddings, Corporate Events, and Parties",
    "WhyChoosedescription": "From wedding guest transport to corporate event shuttles and birthday parties, our Innova Crysta cabs add a touch of luxury and reliability to every occasion."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Smooth Event Planning",
    "WhyChoosedescription": "Our dedicated customer service team is available around the clock to assist with bookings, itinerary changes, and special requests, ensuring your event transportation goes off without a hitch."
  }
]




















    }

const faqData = [
    {
        question: "Can I hire an Innova Crysta for events in Pune?",
        answer: "Yes, Meghana Cab offers Innova Crysta car hire services for all types of events including weddings, corporate functions, and private gatherings in Pune."
    },
    {
        question: "What kind of events do you provide Innova Crysta for?",
        answer: "We provide services for weddings, conferences, airport pick-up for guests, VIP movements, exhibitions, and other special occasions."
    },
    {
        question: "How many guests can travel in an Innova Crysta?",
        answer: "The Innova Crysta can comfortably accommodate 6 to 7 passengers along with luggage."
    },
    {
        question: "Are the vehicles available for hourly and full-day rental?",
        answer: "Yes, we offer flexible rental options including hourly packages and full-day bookings based on your event schedule."
    },
    {
        question: "Can I hire multiple Innova Crystas for large events?",
        answer: "Absolutely. We can arrange a fleet of Innova Crystas for your event upon request with advance booking."
    },
    {
        question: "Are the cars clean and well-maintained for events?",
        answer: "Yes, all our vehicles are maintained to premium standards, sanitized, and presented in pristine condition for every booking."
    },
    {
        question: "Can the driver be in formal attire for professional events?",
        answer: "Yes, we can arrange for drivers in formal dress upon request for corporate and formal events."
    },
    {
        question: "Do you offer airport transfers for event guests?",
        answer: "Yes, we offer punctual and comfortable airport pick-up/drop-off services for event guests."
    },
    {
        question: "How early should I book the vehicle for my event?",
        answer: "We recommend booking at least 24 to 48 hours in advance, especially during peak event seasons."
    },
    {
        question: "What payment options do you offer?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash payments for convenience."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Bafna',
        designation: 'Event Organizer',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked multiple Innova Crystas for a wedding event in Pune. Vehicles were on time and in perfect condition.”',
    },
    {
        name: 'Ms. Pooja Desai',
        designation: 'Corporate Client',
        rating: [1, 1, 1, 1, 1],
        text: '“Used Meghana Cab for transporting delegates during our seminar. Clean cars, courteous drivers, and smooth coordination.”',
    },
];






























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const eventInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Crysta Car Hire for Events in Pune",
  "description": "Premium and affordable chauffeur-driven Innova Crysta car rental service for weddings, corporate events, birthday parties, festivals, and other special occasions in Pune. Comfortable and reliable event car hire.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Event Car Rental Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/innova-crysta-car-hire-events-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Innova Crysta Car Hire for Events in Pune | Event Taxi Service</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta cabs for weddings, corporate events, birthday parties, and festivals in Pune. Affordable and premium event car rental service."
  />
  <meta
    name="keywords"
    content="Innova Crysta Car Hire for Wedding Pune, Event Car Rental Innova Crysta Pune, Corporate Event Innova Crysta Hire Pune, Birthday Party Innova Crysta Car Rental Pune, Chauffeur Driven Event Car Pune, Online Event Car Booking Pune, Luxury Innova Crysta Hire Pune, Affordable Innova Crysta Rental Pune, Festival Car Hire Innova Crysta Pune, Special Occasion Car Rental Pune, Premium Event Taxi Pune, Comfortable Innova Crysta Event Cab, Family Event Innova Crysta Hire, Conference Car Rental Pune, Group Event Car Booking Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(eventInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/15.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystacarhireforeventpune;